import { FShallowNodeTypesEnum } from '@spazious/dollhouse-shallow-graph';

import { useLayers } from '../../hooks/index.js';
import { MeasurementNode } from '../../types/index.js';

export type MeasurementProps = GraphNodeProps<MeasurementNode>;

export const Measurement: React.FC<MeasurementProps> = (props) => {
  const layers = useLayers();

  return (
    <measurement
      {...props}
      visible={props.visible !== false && layers.isEnabled(FShallowNodeTypesEnum.Measurement)}
    />
  );
};
